/**
 * start.gg 連携の設定値（PoC）。機密でない値のみ。
 * client_id / client_secret / scope は backend 側にのみ置く（authorize URL は backend が組み立てる）。
 *
 * - REACT_APP_STARTGG_REDIRECT_URI     start.gg 登録済みの callback（authorize/token交換で完全一致）
 * - REACT_APP_STARTGG_TOURNAMENT_SLUG  参加登録 iframe の対象大会 slug
 * - REACT_APP_STARTGG_TOURNAMENT_ID    entry 突合に使う Tournament.id
 * - REACT_APP_STARTGG_EVENT_ID         この Event に entry しているかを判定
 */
export const startggConfig = {
  redirectUri: process.env.REACT_APP_STARTGG_REDIRECT_URI ?? "",
  tournamentSlug: process.env.REACT_APP_STARTGG_TOURNAMENT_SLUG ?? "",
  tournamentId: process.env.REACT_APP_STARTGG_TOURNAMENT_ID ?? "",
  eventId: process.env.REACT_APP_STARTGG_EVENT_ID ?? "",
} as const;

/**
 * start.gg 公式の登録ページ URL（別タブで開く用）。
 * iframe 埋め込み(/register/embed)は third-party cookie 依存で不安定なため、
 * first-party の通常登録ページを別タブで開く。
 */
export const startggRegisterUrl = (): string =>
  `https://start.gg/tournament/${startggConfig.tournamentSlug}/register`;
